import { render } from "./MotmTeaserB.vue?vue&type=template&id=6c98a7e6&scoped=true"
import script from "./MotmTeaserB.vue?vue&type=script&lang=js"
export * from "./MotmTeaserB.vue?vue&type=script&lang=js"

import "./MotmTeaserB.vue?vue&type=style&index=0&id=6c98a7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c98a7e6"]])

export default __exports__